export default __webpack_public_path__ + "static/media/map-pin.e40ce05e.svg";